









































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import DropupLayout from "@/views/Dropups/DropupLayoutV2.vue";
import ReceiverPhone from "@/views/Dropups/views/ReceiverPhone.vue";
import DroppoButton from "@/views/components/DroppoButton.vue";
import CellChooserWrapper from "@/views/Dropups/views/CellChooserWrapper.vue";
import SelectHub from "@/views/Dropups/views/SelectHub.vue";
import TextAreaInput from "@/views/components/FormInputs/TextAreaInput.vue";
import {namespace} from "vuex-class";
import {IHub, initialHub} from "@/models/StoreModels";
import {CELL_SIZES, cellSizesTranslatedStrings, ORDER_PROCESS_DROPUP_PAGE} from "@/constants/orders";

const shipmentStore = namespace("shipment");
const hubsStore = namespace("hubs");

@Component({
  name: 'OrderButtonLocationSize',
  components: {
    DropupLayout,
    ReceiverPhone,
    DroppoButton,
    CellChooserWrapper,
    SelectHub,
    TextAreaInput,
  },
})
export default class OrderButtonLocationSize extends Vue {
  @hubsStore.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  @hubsStore.Getter("getHubById")
  private getHubById!: (a: number) => IHub;

  @shipmentStore.Action("setCellSize")
  private setCellSize!: (re: number) => void;

  @shipmentStore.Action("setFromHubId")
  private setFromHubId!: (re: number) => void;

  @shipmentStore.Getter("getCellSize")
  private getCellSize!: CELL_SIZES;

  @shipmentStore.Getter("getFromHubId")
  private getFromHubId!: number;

  @Prop({ default: false })
  private onlyMap!: boolean;

  @Prop({ default: false })
  private preventSave!: boolean;

  @Prop({ default: false })
  private fillWidth!: boolean;

  private dropupPage: ORDER_PROCESS_DROPUP_PAGE = ORDER_PROCESS_DROPUP_PAGE.EMPTY_PAGE;
  private cellSize: CELL_SIZES = CELL_SIZES.UNDEFINED_SIZE;
  private fromHub: IHub = initialHub();
  private dropupOpen: boolean = false;

  get dropOffCellSizeAndAddress(): string {
    let myText = '';

    if (!this.existsOnlyOneHub) {
      myText = `${this.fromHub.address}<br>`;
    }

    return `${ myText }${ this.onlyMap ? "" : this.sizeHumanReadable}`;
  }

  get sizeHumanReadable(): string {
    return cellSizesTranslatedStrings(this.cellSize);
  }

  get isDataValid(): boolean {
    // onlyMap && this.fromHub.id > 0
    // (onlyMap || this.cellSize) && this.fromHub.id > 0


    return (this.onlyMap || this.cellSize > 0) && this.fromHub.id > 0;
  }

  get isCellChooser() {
    return this.dropupPage === ORDER_PROCESS_DROPUP_PAGE.CELL_CHOOSER;
  }

  get isSelectHub() {
    return this.dropupPage === ORDER_PROCESS_DROPUP_PAGE.SELECT_HUB;
  }

  @Watch('$route')
  private checkDropup() {
    const dropupParam: ORDER_PROCESS_DROPUP_PAGE = this.$route.params.dropup ?
        this.$route.params.dropup as ORDER_PROCESS_DROPUP_PAGE :
        ORDER_PROCESS_DROPUP_PAGE.EMPTY_PAGE;

    if ((!this.onlyMap && dropupParam === ORDER_PROCESS_DROPUP_PAGE.CELL_CHOOSER) ||
        dropupParam === ORDER_PROCESS_DROPUP_PAGE.SELECT_HUB) {
      this.dropupPage = dropupParam;
      this.dropupOpen = true; // to open with the route
    }
  }

  private created() {
    if (this.onlyMap) {
      this.goToMap();
    }
    this.updateLockerSize(this.getCellSize);
    this.updateHub(this.getHubById(this.getFromHubId));
    this.updateIsValidData();
  }

  private updateHub(hub: IHub) {
    this.fromHub = hub;
    if (!this.preventSave) {
      this.setFromHubId(this.fromHub.id);
    }
    this.$emit("orderButtonLocationSize:updateHub", this.fromHub);
    this.updateIsValidData();
  }

  private goToMap() {
    this.dropupPage = ORDER_PROCESS_DROPUP_PAGE.SELECT_HUB;
  }

  private updateLockerSize(lockerSize: CELL_SIZES) {
    this.cellSize = lockerSize;
    if (!this.preventSave) {
      this.setCellSize(this.cellSize);
    }
    this.$emit("orderButtonLocationSize:updateLockerSize", this.cellSize);
    this.updateIsValidData();
  }

  private goOpenDropoff() {
    if (!this.onlyMap) {
      this.dropupPage = ORDER_PROCESS_DROPUP_PAGE.CELL_CHOOSER;
    }

    this.dropupOpen = true;
  }

  private updateIsValidData() {
    this.$emit("orderButtonLocationSize:isDataValid", this.isDataValid );
  }

  private closeDropup() {
    this.dropupOpen = false;
  }
}
